export enum OfficeOfferPriceType {
  RENT_MONTHLY = 'rent_monthly',
  RENT_SURFACE = 'rent_surface',
  RENT_WORKSTATION = 'rent_workstation',
}
